(function() {
  var arrayUtil,
    slice = [].slice;

  arrayUtil = exports;

  arrayUtil.copySort = function(arr, comparator) {
    if (comparator == null) {
      comparator = void 0;
    }
    return $.merge([], arr).sort(comparator);
  };

  arrayUtil.closest = function(arr, goal) {
    var closest, d, el, i, len, minDiff, n;
    if (goal == null) {
      goal = 0;
    }
    closest = null;
    minDiff = null;
    for (i = 0, len = arr.length; i < len; i++) {
      el = arr[i];
      n = parseInt(el);
      d = Math.abs(n - goal);
      if ((closest == null) || d < minDiff || (d === minDiff && n > closest)) {
        closest = n;
        minDiff = d;
      }
    }
    return closest;
  };

  arrayUtil.insertSorted = function(arr, item, comparator) {
    var index;
    if (comparator == null) {
      comparator = function(a, b) {
        if (typeof a !== 'string') {
          a = String(a);
        }
        if (typeof b !== 'string') {
          b = String(b);
        }
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      };
    }
    index = (function(arr, item) {
      var max, min, result;
      min = 0;
      max = arr.length;
      index = Math.floor((min + max) / 2);
      while (max > min) {
        result = comparator(item, arr[index]);
        if (result < 0) {
          max = index;
        } else {
          min = index + 1;
        }
        index = Math.floor((min + max) / 2);
      }
      return index;
    })(arr, item);
    return arr.splice(index, 0, item);
  };

  arrayUtil.joinPretty = function(arr, join_text, empty_text) {
    var i, last, most;
    if (join_text == null) {
      join_text = 'and';
    }
    if (empty_text == null) {
      empty_text = 'nothing';
    }
    switch (arr.length) {
      case 0:
        return empty_text;
      case 1:
        return arr[0];
      case 2:
        return arr[0] + " " + join_text + " " + arr[1];
      default:
        most = 2 <= arr.length ? slice.call(arr, 0, i = arr.length - 1) : (i = 0, []), last = arr[i++];
        return (most.join(', ')) + ", " + join_text + " " + last;
    }
  };

}).call(this);
